import { render, staticRenderFns } from "./bagDetail.vue?vue&type=template&id=b8ac82be&scoped=true&"
import script from "./bagDetail.vue?vue&type=script&lang=js&"
export * from "./bagDetail.vue?vue&type=script&lang=js&"
import style0 from "./bagDetail.vue?vue&type=style&index=0&id=b8ac82be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ac82be",
  null
  
)

export default component.exports